import {connect} from 'react-redux';

import {TeamModel} from '../../../../../libs/shared/core/src/models/api/teamModel';
import {WorkspaceDisplaySectionTrackingTypesEnum} from '../../../../../libs/shared/core/src/models/tracking/contexts/workspaceTracking';
import {
  InterfaceEventsEnum,
  trackInterfaceEvent,
} from '../../../../../libs/shared/core/src/services/tracking/tracking';
import {getShouldHideTeamTagCounters} from '../../../../../libs/shared/core/src/store/featureFlags/featureFlagsSelectors';
import {createSelector, makeMapStateToProps} from '../../../../../srcCommon/helpers/reselectHelpers';
import {PermissionsEnum} from '../../../../models/api/roleModel';
import {VisualWorkspaceTag} from '../../../../models/api/visualWorkspaceModel';
import {AppState} from '../../../../store/appState';
import {getHasPermission} from '../../../../store/data/access/accessSelectors';
import {getShouldAlphabetizeWorkspace} from '../../../../store/data/preferences/preferencesSelectors';
import {WorkspaceDropReorderTeamViewArgs} from '../../../../store/data/workspace/reorder/types';
import {makeGetVisualWorkspaceVisualCustomViewsForTeam} from '../../../../store/data/workspace/visualWorkspace/visualWorkspaceSelectors';
import {reorderViewInTeamWorkspaceAsyncAction} from '../../../../store/data/workspace/workspaceActions';
import {TeamWorkspaceCustomViews} from './teamWorkspaceCustomViews';

/*
 * Props.
 */

interface TeamWorkspaceCustomViewsContainerProps {
  team: TeamModel;
  visualWorkspaceCustomViewsForTeam: ReadonlyArray<VisualWorkspaceTag>;
}

/*
 * Selectors.
 */

function getTeamNamespace(_state: AppState, props: TeamWorkspaceCustomViewsContainerProps) {
  return props.team.namespace;
}

function getVisualWorkspaceCustomViewsForTeam(
  _state: AppState,
  props: TeamWorkspaceCustomViewsContainerProps,
) {
  return props.visualWorkspaceCustomViewsForTeam;
}

function getOptionalAdditionalTagsMap() {
  return undefined;
}

function makeGetHasEditViewPermission() {
  return createSelector([getHasPermission, getTeamNamespace], (hasPermission, namespace) =>
    hasPermission(namespace, PermissionsEnum.EDIT_VIEW),
  );
}

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<TeamWorkspaceCustomViewsContainerProps>()(() => ({
  visualCustomViews: makeGetVisualWorkspaceVisualCustomViewsForTeam(
    getVisualWorkspaceCustomViewsForTeam,
    getOptionalAdditionalTagsMap,
    true,
  ),
  hasEditPermission: makeGetHasEditViewPermission(),
  shouldAlphabetizeWorkspace: getShouldAlphabetizeWorkspace,
  shouldHideTeamTagCounters: getShouldHideTeamTagCounters,
}));

export const TeamWorkspaceCustomViewsContainer = connect(mapStateToProps, {
  onDropReorderTeamView: (dropArgs: WorkspaceDropReorderTeamViewArgs) => {
    trackInterfaceEvent(InterfaceEventsEnum.P1_WORKSPACE_REORDER, {
      section: WorkspaceDisplaySectionTrackingTypesEnum.CUSTOM_VIEW,
    });
    return reorderViewInTeamWorkspaceAsyncAction(dropArgs);
  },
})(TeamWorkspaceCustomViews);
